import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class GoogleService {
    constructor(private api: ApiService) {

    }

    getCoordinates(cityState) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithoutAuthAndContentType('https://maps.googleapis.com/maps/api/geocode/json?address=' + cityState + '&sensor=false&key=AIzaSyDih3XvuWn1fsfbHfNThU7AWlld0gUCFsM')
                .then(data => resolve(data), error => reject(error));
        });
    }

    getTimezone(coordinates, timestamp) {
        return new Promise((resolve, reject) => {
            console.log('url: ', 'https://maps.googleapis.com/maps/api/timezone/json?location=' + coordinates + '&timestamp=' + timestamp + '&key=AIzaSyDih3XvuWn1fsfbHfNThU7AWlld0gUCFsM');
            this.api
                .getWithoutAuthAndContentType('https://maps.googleapis.com/maps/api/timezone/json?location=' + coordinates + '&timestamp=' + timestamp + '&key=AIzaSyDih3XvuWn1fsfbHfNThU7AWlld0gUCFsM')
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/google.service.ts